// extracted by mini-css-extract-plugin
export default {"header_avatar":"ClientsAvatar_header_avatar__yQxHN","s":"ClientsAvatar_s__wda0l","header_role":"ClientsAvatar_header_role__Ll6QU","header_image":"ClientsAvatar_header_image__mftTv"};